import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, Lock, CreditCard } from 'lucide-react';
import { trackInitiateCheckout } from '../lib/pixel';
const includes = ['Guía principal Sistema iPhone Ads (PDF).', 'Bonus 1: Estructura de Campañas para vender iPhones con Instagram Ads (PDF).', 'Bonus 2: Creación de Contenido para vender iPhones con Reels y Anuncios (PDF).', 'Acceso digital inmediato.', 'Lectura a tu ritmo, sin límite de tiempo.', 'Pensado para tiendas, revendedores y personas que recién empiezan.'];
export function Pricing() {
  return <section id="comprar" className="py-20 md:py-32 bg-zinc-950 relative overflow-hidden" data-id="element-252">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-2xl h-[500px] bg-blue-600/20 rounded-full blur-[100px] pointer-events-none" data-id="element-253"></div>

      <div className="max-w-4xl mx-auto px-4 md:px-6 relative z-10" data-id="element-254">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-255">
          <h2 className="text-3xl md:text-5xl font-extrabold text-white tracking-tight mb-6" data-id="element-256">
            Accedé a la guía práctica de Sistema iPhone Ads
          </h2>
          <p className="text-base md:text-lg text-zinc-400 max-w-2xl mx-auto text-balance" data-id="element-257">
            Una guía pensada para dueños de tiendas, revendedores y personas que
            están empezando y quieren aprender a vender iPhones con anuncios más
            claros, más estratégicos y con mejores conversaciones.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-white rounded-3xl overflow-hidden shadow-2xl max-w-2xl mx-auto" data-id="element-258">
          <div className="p-8 md:p-12" data-id="element-259">
            <div className="grid md:grid-cols-2 gap-8 items-center" data-id="element-260">
              <div data-id="element-261">
                <h3 className="text-lg font-bold text-zinc-900 mb-6 uppercase tracking-wider" data-id="element-262">
                  Qué incluye
                </h3>
                <ul className="space-y-4" data-id="element-263">
                  {includes.map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-264">
                      <CheckCircle2 className="w-5 h-5 text-blue-600 shrink-0 mt-0.5" data-id="element-265" />
                      <span className="text-zinc-700 font-medium leading-snug" data-id="element-266">
                        {item}
                      </span>
                    </li>)}
                </ul>
              </div>

              <div className="bg-zinc-50 p-6 md:p-8 rounded-2xl border border-zinc-200 text-center" data-id="element-267">
                <div className="text-sm font-bold text-blue-600 uppercase tracking-wider mb-2" data-id="element-268">
                  Precio lanzamiento
                </div>
                <div className="text-4xl md:text-5xl font-extrabold text-zinc-900 mb-6" data-id="element-269">
                  $14.900{' '}
                  <span className="text-xl text-zinc-500 font-medium" data-id="element-270">ARS</span>
                </div>

                <a href="https://sistema-iphone-ads.myshopify.com/products/sistema-iphone-ads" onClick={trackInitiateCheckout} className="block w-full py-4 px-6 text-lg font-bold text-white bg-blue-600 rounded-xl hover:bg-blue-700 transition-colors shadow-lg hover:shadow-xl mb-4" data-id="element-271">
                  Comprar guía ahora
                </a>

                <div className="flex flex-wrap items-center justify-center gap-x-4 gap-y-2 text-xs text-zinc-500 mb-4" data-id="element-272">
                  <div className="flex items-center gap-1" data-id="element-273">
                    <Lock className="w-4 h-4" data-id="element-274" /> Pago seguro
                  </div>
                  <div className="flex items-center gap-1" data-id="element-275">
                    <CreditCard className="w-4 h-4" data-id="element-276" /> Acceso digital
                  </div>
                  <div className="flex items-center gap-1" data-id="element-277">
                    <span aria-hidden data-id="element-278">·</span> Descarga inmediata
                  </div>
                </div>

                {/* Mercado Pago badge */}
                <div className="flex flex-col items-center gap-2 p-3 bg-white rounded-xl border border-zinc-200" data-id="element-279">
                  <img src="https://cdn.magicpatterns.com/uploads/nSgspcC5xecoVkyTKwF93i/Mercado_Pago.svg.png" alt="Mercado Pago" width={96} height={36} loading="lazy" decoding="async" className="h-7 w-auto object-contain" data-id="element-280" />
                  <p className="text-[11px] text-zinc-600 leading-snug text-center" data-id="element-281">
                    <span className="font-semibold text-zinc-800" data-id="element-282">
                      Pago seguro con Mercado Pago.
                    </span>
                    <br data-id="element-283" />
                    Podés abonar con los medios disponibles dentro de Mercado
                    Pago.
                  </p>
                </div>
                <p className="text-[11px] text-zinc-500 mt-3 leading-snug" data-id="element-284">
                  Pago procesado de forma segura a través de Mercado Pago.
                </p>
              </div>
            </div>
          </div>

          <div className="bg-blue-600 p-4 text-center" data-id="element-285">
            <p className="text-white font-medium text-sm md:text-base" data-id="element-286">
              "Con una campaña bien armada que te ayude a vender un equipo más,
              la guía ya puede pagarse sola."
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}